var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2410e2bdbc29a969fafd906703d45ffe2026ef3f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kikushiru@inditidual"]={id:"2410e2bdbc29a969fafd906703d45ffe2026ef3f"};
      